const PusherEventNames = {
  ADD_NOTIFICATION: "addNotification",
  UPDATE_COUNTS: "updateCounts",
  UPDATE: "update",
  LOGOUT: "logout"
} as const;

export default PusherEventNames;
